import { IAction, TActionTypes } from '@Root/types'

import {
  IFollowedExportation,
  IGetFollowedExportationsSuccessPayload,
  IAddFollowedExportationPayload,
  IRemoveFollowedExportationPayload,
} from '@EditorModules/Exportation/types'

export const ExportationActionTypes = {
  GET_FOLLOWED_EXPORTATIONS: '@@exportation/GET_FOLLOWED_EXPORTATIONS',
  GET_FOLLOWED_EXPORTATIONS_SUCCESS: '@@exportation/GET_FOLLOWED_EXPORTATIONS_SUCCESS',
  ADD_FOLLOWED_EXPORTATION: '@@exportation/ADD_FOLLOWED_EXPORTATION',
  REMOVE_FOLLOWED_EXPORTATION: '@@exportation/REMOVE_FOLLOWED_EXPORTATION',
}

export interface IExportationState {
  readonly followedExportations: IFollowedExportation[]
  readonly followedExportationIds: number[]
}

export type TExportationActionTypes =
  TActionTypes |
  IAction<IGetFollowedExportationsSuccessPayload> |
  IAction<IAddFollowedExportationPayload> |
  IAction<IRemoveFollowedExportationPayload>
